import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export const CALENDAR_TZ_STORAGE_KEY = "calendar.tz";

interface TimezoneSelectProps {
  value: string;
  onChange: (tz: string) => void;
}

function userLocalTz(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "Etc/UTC";
  } catch {
    return "Etc/UTC";
  }
}

export function TimezoneSelect({ value, onChange }: TimezoneSelectProps) {
  const localTz = userLocalTz();
  const handleChange = (next: string) => {
    localStorage.setItem(CALENDAR_TZ_STORAGE_KEY, next);
    onChange(next);
  };
  return (
    <Select value={value} onValueChange={handleChange}>
      <SelectTrigger className="h-8 w-[180px] text-xs">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="America/New_York">New_York (ET)</SelectItem>
        <SelectItem value="Etc/UTC">UTC</SelectItem>
        {localTz !== "America/New_York" && localTz !== "Etc/UTC" && (
          <SelectItem value={localTz}>{localTz} (local)</SelectItem>
        )}
      </SelectContent>
    </Select>
  );
}
